import { createSelector } from "reselect";
import { config as selectConfig } from "../state/config/config.selector";
import type { AppState } from "../state/root.reducer";
import {
  getWorkspaceThumbnailUrl,
  selectDashboardWorkspaceDetailsById,
} from "../state/workspaces/workspaces.selector";

export const createSelectThumbnailUrlByWorkspaceId = () =>
  createSelector(
    [
      selectConfig,
      selectDashboardWorkspaceDetailsById,
      (_: AppState, workspaceId?: string) => workspaceId,
    ],
    (config, dashboardWorkspaceDetails, workspaceId) => ({
      thumbnailUrl:
        workspaceId && getWorkspaceThumbnailUrl(workspaceId, config),
      thumbnailChanged: !!dashboardWorkspaceDetails?.thumbnailChanged,
    }),
  );
